import { Suspense, useContext, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const WarehouseTool = lazy(() => import('~/apps/smartsend/components/warehouse/WarehouseTool'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('PICKANDPACK_PAGE_TITLE', { defaultValue: 'Picking and Packing' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.PickAndPacking }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.PickAndPacking
      }
    });
  });

  return (
    <Tagged tag="screen-pick-and-pack">
      <Suspense>
        <WarehouseTool />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'SmartSend: Picking and Packing';
